import type { Citation, MessageType } from "@expert/shared-types";

import type { ExpertAssistMetadata } from "../../shared-types";

import { CitationsHeader } from "./custom-messages/CitationsHeader";
import { GuideRecommendationHeader } from "./custom-messages/GuideRecommendation";
import { SessionSummaryHeader } from "./custom-messages/SessionSummary";

export function MessageBubbleHeader({
    isLastProactiveMessage,
    type,
    metadata,
    citations,
}: {
    isLastProactiveMessage: boolean;
    type: MessageType;
    metadata?: ExpertAssistMetadata;
    citations?: Citation[] | null;
}) {
    const { sessionSummary, guideRecommendation } = metadata || {};
    if (type === "SessionSummary" && sessionSummary) {
        return <SessionSummaryHeader metadata={sessionSummary} isLastProactiveMessage={isLastProactiveMessage} />;
    }

    if (type === "GuideRecommendation" && guideRecommendation) {
        return <GuideRecommendationHeader guideTitle={guideRecommendation} />;
    }

    if (citations && citations.length > 0) {
        return <CitationsHeader citations={citations} />;
    }
}
